import React, { useCallback, useEffect, useMemo, useState } from 'react'
// import { useNavigate } from "react-router-dom";

import moment from "moment";
import { format, addWeeks, addMonths } from "date-fns";
import { Close, Edit } from "@mui/icons-material";

// import { useAuth } from "../contexts/authcontext";
// import { useMember } from "../contexts/membercontext";
// import { useKitchen } from "../contexts/kitchencontext";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import { ReactComponent as UpArrow } from "../icons/VectorUp.svg";
// import { ReactComponent as DownArrow } from "../icons/VectorDown.svg";
import { ReactComponent as RightArrow } from "../icons/ScrollRightArrow.svg";
import { ReactComponent as LeftArrow } from "../icons/ScrollLeftArrow.svg";
import { ReactComponent as CalendarIcon } from "../icons/CalendarIcon.svg";

import { useAuthState } from '../contexts/authcontext'
import { useMemberState } from '../contexts/membercontext'
// import { useAddBooking } from '../hooks/memberhooks'
// import { useResourceState } from '../contexts/kitchencontext'

import  EquipmentsWidget from './EquipmentsWidget'
import LoadingScreen from "../pages/shared/LoadingScreen"

import { FeeSchema, MembershipSchema, ResourceBookingSchema, ResourceSchema, ResourceType, TimeBlock } from "../data/types";
import ReservationCalendar from "./ReservationCalendar";
import BookingConfirmation from "../molecules/BookingConfirmation";
import { useAddBooking, useGetPaymentMethods, useLoadMemberships } from '../hooks/memberhooks'
import { useLoadCurrentResource } from '../hooks/resourcehooks';
import { AddFeeModal } from '../molecules/AppModal';

type StartBookingProps = {
  resourceId: string
  handleClose: () => void
  isOpen?: boolean
  
};


const StartKitchenBooking: React.FC<StartBookingProps> = ({isOpen, handleClose, resourceId}) => {
  // const navigate = useNavigate()
  // var { schoolId } = useParams();

  var { authUser,  isloggedin } = useAuthState()
  var { memberships } = useLoadMemberships()
  var { bookings } = useMemberState()
  const { currentResource } = useLoadCurrentResource(resourceId)
  // var { currentBooking } = useLoadBooking(resourceId)
  const resourceType = currentResource?.resource_type
  var { addNewBooking, isLoadingBooking, isAddBookingSuccess, isAddBookingError } = useAddBooking(resourceType as ResourceType)
  // var { plans } = useResourceState()
  // console.log("resourceId", resourceId)
  
  // console.log("currentResource", currentResource)

  useEffect(() => { 
    setMember(memberships ? memberships[0] : {} as MembershipSchema);
    // eslint-disable-next-line 
  }, [])
  
  
  // const getNext30MinuteInterval = (dateTime?: any) => {
  //   dateTime = dateTime ? moment(dateTime) : moment() // 2023-06-07T08:54 vs 2023-06-07T08:10
  //   var minutes = dateTime.minutes()
  //   var remainder = 30 - minutes
  //   var next30MinMark = dateTime.minutes(0)
  //   if (remainder < 0){
  //     next30MinMark = dateTime.minutes(minutes + remainder)
  //     next30MinMark.add(30, 'minutes')
  //   } else if (remainder < 30){
  //     next30MinMark.minutes(minutes + remainder)
  //   }
  //   // eslint-disable-next-line
  // }, []);

  const getNext30MinuteInterval = (dateTime?: any) => {
    dateTime = dateTime ? moment(dateTime) : moment(); // 2023-06-07T08:54 vs 2023-06-07T08:10
    var minutes = dateTime.minutes();
    var remainder = 30 - minutes;
    var next30MinMark = dateTime.minutes(0);
    if (remainder < 0) {
      next30MinMark = dateTime.minutes(minutes + remainder);
      next30MinMark.add(30, "minutes");
    } else if (remainder < 30) {
      next30MinMark.minutes(minutes + remainder);
    }
    return next30MinMark.format("YYYY-MM-DDTHH:mm");
  };

  const [startDate, updateStartDate] = useState(getNext30MinuteInterval());
  const [endDate, updateEndDate] = useState(startDate);
  const [nHours, updateNHours] = useState(0);
  // const [isBookingRequest, toggleBookingRequest] = useState<boolean>(false)
  const [selectedEquipments, updateSelectedEquipments] = useState<string[]>([]);
  const [member, setMember] = useState<MembershipSchema>(); // Change the type according to your data type
  // const [memberUsername, setMemberUsername] = useState<string>(""); // Change the type according to your data type
  // const [isExistingMember, setIsExistingMember] = useState<boolean>(true);
  const isExistingMember = true
  // const [view, setView] = useState<"month" | "week">("week");

  const { paymentMethods } = useGetPaymentMethods(member?.uid ? member.uid : "")
  const [selectedPayMethod, updateSelectedPayMethod] = useState<string>(paymentMethods && paymentMethods.length > 0 && paymentMethods.length[0]?.id ? paymentMethods.length[0]?.id : "")


  var view =  "week"
  // const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const [currentDate, setCurrentDate] = useState<Date>(new Date());
  // const [beforeBuffer, setBeforeBuffer] = useState("");
  var beforeBuffer = "0"
  // const [afterBuffer, setAfterBuffer] = useState("");
  var afterBuffer = "0"
  // const buffers = [15, 30, 45, 60];
  const [step, setStep] = useState(0);
  const [newBookings, setNewBooking] = useState<ResourceBookingSchema>();
  const [bookingNotes, updateBookingNotes] = useState<string>("")

  const next = () => {
    setCurrentDate(
      view === "month" ? addMonths(currentDate, 1) : addWeeks(currentDate, 4)
    );
  };

  const prev = () => {
    setCurrentDate(
      view === "month" ? addMonths(currentDate, -1) : addWeeks(currentDate, -4)
    );
  };
  const handleMemberChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    // setMemberUsername(value);
    if (value) {
      // console.log("value", JSON.parse(value))
      setMember(JSON.parse(value));
    } else {
      setMember({});
    }
  };

  const handleBooking = async (option: string) => {
    let memberUsername = member?.username;
    if (
      isloggedin &&
      currentResource &&
      authUser &&
      memberUsername &&
      startDate &&
      endDate &&
      endDate > startDate &&
      startDate !== endDate
    ) {
      var newBooking: ResourceBookingSchema = {
        has_reminder: false,
        community_id: currentResource.community_id
          ? currentResource.community_id
          : "",
        start_time: moment(startDate)
          .set("minutes", moment(startDate).minutes() - Number(beforeBuffer))
          .format('YYYY-MM-DDTHH:mm')
          .toString(),
        end_time: moment(endDate)
          .set("minutes", moment(endDate).minutes() + Number(afterBuffer))
          .format('YYYY-MM-DDTHH:mm').toString(),
        resource_type: "kitchen",
        username: memberUsername,
        location: currentResource.location
          ? currentResource.location
          : currentResource.country
          ? currentResource.country
          : "",
        notes: bookingNotes,
        payment_method: selectedPayMethod,
        fees: currentResource.fees,
        // by_admin: true,
        // resource_id: resourceId
      };
      if (option === "confirm") {
        setNewBooking(newBooking);
      }

      if (option === "submit"){
          addNewBooking(resourceId, newBooking)
          if (isLoadingBooking || isAddBookingSuccess){
            handleClose() 
          }
      }
    }
  };

  // const handleDateTimeChange = (
  //   e: React.ChangeEvent<HTMLInputElement>,
  //   dateType: string
  // ) => {
  //   e.preventDefault();
  //   const newDate = e.target.value;
  //   var duration = moment.duration(moment(endDate)?.diff(moment(startDate)));

  //   if (dateType === "startDate" && moment(newDate) >= moment(new Date())) {
  //     // update start time
  //     updateStartDate(getNext30MinuteInterval(newDate));
  //     if (moment(newDate) > moment(endDate)) {
  //       updateEndDate(getNext30MinuteInterval(newDate));
  //     }
  //     duration = moment.duration(
  //       moment(getNext30MinuteInterval(endDate))?.diff(
  //         moment(getNext30MinuteInterval(newDate))
  //       )
  //     );
  //   } else if (dateType === "endDate" && moment(newDate) >= moment(startDate)) {
  //     // update end time
  //     updateEndDate(getNext30MinuteInterval(newDate));
  //     duration = moment.duration(
  //       moment(getNext30MinuteInterval(newDate))?.diff(
  //         moment(getNext30MinuteInterval(startDate))
  //       )
  //     );
  //   }

  //   // calculate hours diff
  //   var hoursDiff = duration.asHours();
  //   if (!isNaN(hoursDiff) && hoursDiff >= 0) {
  //     updateNHours(hoursDiff);
  //   }
  // };



  // Function to handle radio button changes
  // const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   if (event.target.value === "existingMember"){
  //     setIsExistingMember(true);
  //   } else {
  //     setIsExistingMember(false);
  //   }
  // };

  // const handleAfterBufferChange = (
  //   event: React.ChangeEvent<HTMLSelectElement>
  // ) => {
  //   setAfterBuffer(event.target.value);
  // };

  // const handleBeforeBufferChange = (
  //   event: React.ChangeEvent<HTMLSelectElement>
  // ) => {
  //   setBeforeBuffer(event.target.value);
  // };

  const [availableTimeBlocks, setAvailableTimeBlocks] = useState<TimeBlock[] | undefined>();
  const [availableTime, setAvailableTime] = useState<string>();

  const handleTimeChange = (startTime: moment.Moment, endTime: moment.Moment) => {
    // Calculate and store duration in hours
    const duration = moment.duration(endTime.diff(startTime));
    const hoursDiff = duration.asHours();
    if (!isNaN(hoursDiff) && hoursDiff >= 0) {
      updateNHours(hoursDiff);
    }

    // Ensure the times are set on the selectedDay
    const newStartTime = moment(selectedDay).set({
      hour: startTime.hour(),
      minute: startTime.minute(),
    });
    const newEndTime = moment(selectedDay).set({
      hour: endTime.hour(),
      minute: endTime.minute(),
    });

    // Persist the values as ISO-like strings (same format used elsewhere)
    updateStartDate(newStartTime.format("YYYY-MM-DDTHH:mm"));
    updateEndDate(newEndTime.format("YYYY-MM-DDTHH:mm"));

    // Update human-readable string for dropdown
    setAvailableTime(`${newStartTime.format("hh:mm A")} - ${newEndTime.format("hh:mm A")}`);
  };

  const handleTimeBlockSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedBlock = availableTimeBlocks?.find(block => 
      `${moment(block.start).format("hh:mm A")} - ${moment(block.end).format("hh:mm A")}` === e.target.value
    );
    
    if (selectedBlock) {
      handleTimeChange(moment(selectedBlock.start), moment(selectedBlock.end));
    }
  };

  // const defaultRequest: ResourceBookingSchema = {
  //   start_time: "",
  //   end_time: "",
  //   resource_type: "kitchen",
  //   username: "",
  //   location: "",
  // }

  // const [request, setRequest] = useState<ResourceBookingSchema>(defaultRequest);
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDay, setSelectedDay] = useState<Date>(
    startDate ? new Date(startDate) : new Date()
  );
  // const [currentCalendarDate, setCurrentCalendarDate] = useState<Date>(new Date());


  const handleDateChange = useCallback((date: Date) => {
    setSelectedDay(date);
    if (date && startDate && endDate) {
      let newStartTime: moment.Moment, newEndTime: moment.Moment;
      
      // If we have available time blocks, use the first one's time portions
      if (availableTimeBlocks && availableTimeBlocks.length > 0) {
        const firstBlock = availableTimeBlocks[0];
        newStartTime = moment(date).set({
          hour: moment(firstBlock.start).hour(),
          minute: moment(firstBlock.start).minute()
        });
        newEndTime = moment(date).set({
          hour: moment(firstBlock.end).hour(),
          minute: moment(firstBlock.end).minute()
        });
      } else {
        // Fall back to current form values if no available blocks
        const currentStartTime = moment(startDate);
        const currentEndTime = moment(endDate);
        
        newStartTime = moment(date).set({
          hour: currentStartTime.hour(),
          minute: currentStartTime.minute()
        });
        newEndTime = moment(date).set({
          hour: currentEndTime.hour(),
          minute: currentEndTime.minute()
        });
      }

      // setStartDate(newStartTime.format('YYYY-MM-DDTHH:mm'));
      setAvailableTime(`${newStartTime.format('h:mmA')} - ${newEndTime.format('h:mmA')}`);
    }
    setShowCalendar(false);
}, [startDate, endDate, availableTimeBlocks]);   

  const [additionalFees, setAdditionalFees] = useState<Partial<FeeSchema[]>>(currentResource?.fees || []);
  const [additionalNotes, setAdditionalNotes] = useState(bookingNotes || '');


  const totalFromFees = useMemo(() => {
      return additionalFees.reduce((total, fee) => total + (fee?.rate || 0), 0);
  }, [additionalFees]);

  const totalFromBooking = member?.plan_recurrence === "hourly" ? (member?.plan_rate || 0) * nHours : (nHours ? (member?.plan_rate || 0) : 0);

  const total = totalFromFees + totalFromBooking



  const [isOpenFee, setIsOpenFee] = useState(false);

    
  const handleAddFee = async (fee: FeeSchema) => {
      addFee(fee)
      setIsOpenFee(false);
  }
  
  const addFee = (fee: FeeSchema) => {
      setAdditionalFees(fees => [...fees, fee]);
  };

  const removeFee = (index: number) => {
      setAdditionalFees(fees => fees.filter((_, i) => i !== index));
  };
  
  if (isLoadingBooking || isAddBookingError){
    return <LoadingScreen height='h-auto' bgColor='inherit' />
  } else {
    if (handleClose && (isAddBookingSuccess)){handleClose()}
    return (
      <>
      <div className="flex flex-col items-start font-open-sans text-inherit p-2 col-span-1 rounded-md justify-evenly">
        <p
          className={` font-raleway text-[18px] text-black font-semibold mt-2 text-left place-self-start  ${
            step === 1 ? "font-light px-10" : ""
          }`}
        >
          {step === 1 ? "Booking Request" : "Add New Reservation"}
        </p>
        <p className='text-[16px] text-[#4D4D4D]/70 font-open-sans my-1'>
          Fill in the details below to add a reservation.
        </p>
        <div className="w-full h-full mt-2">
          {step === 100 ? (
            <div>
              <div className="flex flex-row w-full m-1 justify-between p-2">
                <p className=" text-sm">Select equipment & supplies</p>
              </div>
  
              <div className="flex flex-col w-full justify-between items-center p-1">
                <EquipmentsWidget
                  selectedEquipments={selectedEquipments}
                  updateSelectedEquipments={updateSelectedEquipments}
                />
              </div>
            </div>
          ) : step === 0 ? (
            <>
            <div>
              <div className='flex flex-col w-full'>
              <div className='flex flex-col w-full'>
                <span className="font-raleway text-black text-[16px] font-medium">Choose member</span>
                <div className="flex flex-row w-full justify-between ">
                  {isExistingMember ? (
                    <select
                      className="border-[1px] border-[#E9E9E9] h-[50px] w-full rounded-lg"
                      value={JSON.stringify(member)}
                      onChange={handleMemberChange}
                    >
                      <option disabled value="">-- Select existing member --</option>
                      {memberships
                        ? memberships.map((m, i) => (
                            <option key={i} value={JSON.stringify(m)}>
                              {m.username}
                            </option>
                          ))
                        : null}
                    </select>
                  ) : (
                    <div className="flex flex-col">
                      <div className="flex">
                        <input
                          placeholder="Full Name"
                          className="formInput mr-1"
                          name="name"
                          type="text"
                        />
                        <input
                          placeholder="Email address"
                          className="formInput"
                          name="email"
                          type="email"
                        />
                      </div>
{/*                       
                      <select className="formInput text-slate-500 mt-1">
                        <option value="">Select a plan</option>
                        {plans
                          ? plans.map((plan, i) => (
                              <option key={i} value={plan.plan_name}>
                                {plan.plan_name}
                              </option>
                            ))
                          : null}
                      </select> */}
                    </div>
                  )}

                  <div className="flex flex-col w-2/3 my-auto">
                    <div className="flex flex-col w-full font-open-sans my-2">
                      {
                        (isExistingMember && member && member.hasOwnProperty("plan_name") && member.plan_name) ? (
                          <div className="flex flex-col w-full font-open-sans my-auto">
                              <div className="flex flex-row ml-auto p-2">
                                <b>PLAN:</b> &nbsp;
                                ${member && member.plan_rate?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} / {member.plan_recurrence}
                              </div>
                          </div>
                        ) : (<></>)
                      }
                    </div>
                  </div> 
                </div>
              </div>                
              <div className="place-self-start w-full flex flex-col gap-5">
                {/* <p className='text-[16px] font-open-sans text-[#4D4D4D]/70 '> */}
                  {/* Choose the length of reservation  */}
                  {/* <span className='text-red-900 italic text-sm'>*</span> */}
                {/* </p> */}
                <div className="grid grid-flow-col grid-cols-2 w-full">
                  <div className="flex flex-row">
                    {/* <p className='text-sm text-primary-200 mr-6'>Number of hours</p> */}
                    {/* <div className="flex flex-row gap-x-5 font-bold"> */}

                      <div className='flex flex-col my-4 w-full'>
                        <span className="font-raleway text-black text-[16px] font-medium">
                          Duration (hours)
                        </span>
                        <label className="flex flex-row text-primary-200 border-[1px] border-[#E9E9E9] h-[50px] w-full rounded-lg">
                          <input
                            placeholder="0"
                            className="border-0 font-open-sans bg-inherit w-full my-1 outline-none text-[#808080]"
                            name="total_hours"
                            type="number"
                            value={nHours}
                            step={1}
                            min={0}
                            // onChange={handleInputChange}
                          />

                          <div
                            onClick={() => {
                              if (nHours > 0 && moment(startDate) < moment(endDate)) {
                                updateNHours(nHours - 0.5);
                                let newEndDate = moment(endDate);
                                newEndDate.subtract(30, "minutes");
                                updateEndDate(getNext30MinuteInterval(newEndDate));
                              }
                            }}
                            className='rounded-full h-[32px] w-[32px] border-[1px] border-[#E9E9E9] p-2 hover:bg-gray-200 cursor-pointer my-auto m-1'
                          >
                            <LeftArrow className=" text-black rounded-full  m-auto" />
                          </div>
                          {/* {nHours.toFixed(1)} */}
                          <div
                            className='rounded-full h-[32px] w-[32px] border-[1px] border-[#E9E9E9] p-2 hover:bg-gray-200 cursor-pointer my-auto m-1'
                            onClick={() => {
                              if (nHours < 24) {
                                updateNHours(nHours + 0.5);
                                let newEndDate = moment(endDate);
                                newEndDate.add(30, "minutes");
                                updateEndDate(getNext30MinuteInterval(newEndDate));
                              }
                            }}
                          >
                              <RightArrow className="text-black rounded-full  my-auto" />
                          </div>
                        </label>
                      {/* </div> */}
                    </div>
                  </div>
                </div>
              </div>

              </div>

              <div className="flex flex-col w-full justify-between mt-2">

  
                {/* <p className='text-md italic text-primary-200'>Choose desired date and timeframe <span className='text-red-900 italic text-sm'>*</span></p> */}
                <span className="font-raleway text-black text-[16px] font-medium">
                  Date
                </span>
  
                <div className="w-full">
                  {/* <label className="font-medium text-gray-700 font-raleway">Date</label> */}
                  <button
                      type="button"
                      className="flex items-center w-full p-2 border-[1px] border-[#E9E9E9] rounded-lg bg-white focus:ring-1"
                      onClick={() => setShowCalendar(prev => !prev)}
                  >
                      <span className="flex-1 text-left text-[16px] text-[#4D4D4D]  font-medium font-open-sans">
                          {selectedDay ? moment(selectedDay).format('MM/DD/YYYY') : 'Select date'}
                      </span>
                      <span className="ml-2 p-1 rounded-full bg-[#F4F8FB] text-primaryDark-200 font-open-sans">
                          <CalendarIcon />
                      </span>
                  </button>


                  {showCalendar && (
                      <div className=" z-50 lg:mt-1 p-4 min-w-[320px] max-w-2xl bg-white border border-[#E9E9E9] rounded-lg shadow-lg">
                          <div className="flex flex-row mb-4">
                              <h2 className="text-[16px]  font-raleway font-medium text-center my-auto text-primary-400">
                              {format(selectedDay, "MMMM yyyy")}
                              </h2>

                              <div className="flex-row justify-between items-center text-slate-400 my-auto ml-auto">
                                  <button 
                                      onClick={prev}
                                      className="mr-4 rounded-full h-[32px] w-[32px] border-[1px] border-[#E9E9E9] p-2 hover:bg-gray-200 cursor-pointer m-auto"
                                  >
                                      <LeftArrow className=" text-black rounded-full  m-auto" />
                                  </button>
                                  <button 
                                      onClick={next}
                                      className="mr-4 rounded-full h-[32px] w-[32px] border-[1px] border-[#E9E9E9] p-2 hover:bg-gray-200 cursor-pointer m-auto"
                                  >
                                      <RightArrow className="text-black rounded-full m-auto" />
                                  </button>
                              </div>
                          </div>
                          <ReservationCalendar
                            currentCalendarDate={selectedDay}
                            resourceBookings={bookings}
                            nHours={nHours}
                            currentResource={currentResource as ResourceSchema}
                            setBlocks={setAvailableTimeBlocks}
                            selectedDay={selectedDay}
                            handleDateChange={handleDateChange}
                          />
                      </div>
                  )}
                </div>
              </div>

              <div className="flex flex-col w-full mt-5">
                <div className="flex flex-row w-full justify-between">
                  <span className="font-raleway text-black text-[16px] font-medium">
                    Time
                  </span>
                  <span className='text-sm my-auto font-medium'>{moment(startDate).format("ddd, LL")}</span>
                </div>
              
                <div className="w-full">
                    <select
                        className="w-full border-[1px]  text-[16px] text-[#4D4D4D]  border-[#E9E9E9] bg-white rounded p-3 font-open-sans"
                        onChange={handleTimeBlockSelect}
                        value={availableTime}
                    >
                        <option disabled value="">-- Select Time Block --</option>
                        {availableTimeBlocks?.map((block, index) => (
                            <option key={index} value={`${moment(block.start).format("hh:mm A")} - ${moment(block.end).format("hh:mm A")}`}>
                                {moment(block.start).format("hh:mm A")} - {moment(block.end).format("hh:mm A")}
                            </option>
                        ))}
                        {
                            !availableTimeBlocks?.length && availableTime && (
                                <option value={availableTime}>{availableTime}</option>
                            )
                        }
                    </select>

                </div>
              </div>  


              <div className="flex flex-col w-full mt-5">
                  <span className="font-raleway text-black text-[16px] font-medium">Additional Fees</span>
                  <div className="mt-1 p-3 border-[2px] border-dashed border-[#E9E9E9] rounded-md space-y-3 bg-gray-50/50">
                      {additionalFees.map((fee, index) => {
                          if (!fee || typeof fee.rate !== 'number' || !fee.name) return null;
                          return (
                              <div key={index}>
                                  <p className="text-gray-700 font-medium mb-1 text-sm font-raleway">{fee.name}</p>
                                  <div className="flex justify-between items-center bg-white p-3 rounded-md border-[1px] border-[#E9E9E9] font-open-sans">
                                      <p className="text-gray-800 font-semibold">${fee.rate.toFixed(2)}</p>
                                      <div className="flex items-center space-x-2">
                                          <button className="p-1 text-gray-500 hover:text-blue-600"><Edit sx={{ fontSize: 20 }} /></button>
                                          <button onClick={() => removeFee(index)} className="p-1 text-gray-500 hover:text-red-600"><Close sx={{ fontSize: 20 }} /></button>
                                      </div>
                                  </div>
                              </div>
                          )
                      })}
                      <button onClick={() => setIsOpenFee(true)} className="flex items-center space-x-2 text-blue-600 font-semibold py-2 px-1">
                          <span className="text-lg font-bold">+</span>
                          <span>Add a Custom Fee</span>
                      </button>
                  </div>
              </div>

              {
                  (additionalNotes && additionalNotes.length > 0) && (
                      <div>
                          <label className="font-medium text-gray-700 font-raleway">Additional Notes</label>
                          <textarea 
                              value={additionalNotes}
                              disabled
                              onChange={e => setAdditionalNotes(e.target.value)}
                              className="mt-1 text-[16px] text-[#4D4D4D] font-open-sans block w-full p-3 border border-[#E9E9E9] rounded-md bg-white focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" placeholder="Add a note" 
                          />
                      </div>
                  )
              }

              <div className="p-4 border bg-gray-50 rounded-md">
                  <div className="flex justify-between items-center">
                      <span className="font-bold text-gray-900">Total</span>
                      <span className="font-bold text-lg text-gray-900">${total.toFixed(2)}</span>
                  </div>
              </div>

              {/* <div className="p-4 rounded-md">
                  <div className="flex justify-between items-center">
                      <span className="font-bold text-gray-900">Payment Method</span>
                      <span className="font-bold text-sm text-gray-900 font-open-sans">
                      {
                          (currentPaymethod && currentPaymethod.card) && (
                              <div className='flex flex-row items-center'>
                                  {getCardIcon(currentPaymethod.card.brand)} &nbsp;
                                  <span className='text-primary-200 font-medium'>
                                      {currentPaymethod.type} ending in {currentPaymethod.card.last4 || '---'} &nbsp;
                                      <span className='text-gray-500 text-sm'>
                                          (Exp: {currentPaymethod.card.exp_month}/{currentPaymethod.card.exp_year})
                                      </span>
                                  </span>
                              </div>
                          ) 
                      }
                      </span>
                  </div>
              </div>   */}


                {/* Footer */}
                <div className="flex justify-end items-center space-x-3 pt-4 mt-2 border-t border-[#E9E9E9] flex-shrink-0 bg-white">
                        <button onClick={handleClose} className="px-5 py-2.5 rounded-md text-gray-700 font-semibold hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 mr-auto text-[16px]">Cancel</button>
                        <div className="flex items-center space-x-3 ml-auto">
                          <button onClick={() => handleBooking("submit")} className="px-5 py-2.5 rounded-md bg-gray-800 text-white font-semibold hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800 text-[16px]">Submit Reservation</button>
                        </div>
                    </div>
                </div>

                {
                    (isOpenFee && <AddFeeModal
                        resource={currentResource}
                        isOpen={isOpenFee}
                        handleAddFee={handleAddFee}
                        closeAppModal={() => setIsOpenFee(false)}
                    />
                    )
                }
            </>
          ) : step === 1 && newBookings ? (
            <div>
              <BookingConfirmation
                currentBooking={newBookings}
                bookingNotes={bookingNotes}
                updateBookingNotes={updateBookingNotes}
                paymentMethods={paymentMethods}
                selectedPayMethod={selectedPayMethod}
                updateSelectedPayMethod={updateSelectedPayMethod}
                member={member}
                beforeBuffer={beforeBuffer}
                afterBuffer={afterBuffer}
                setStep={setStep}
                equipment={selectedEquipments}
                isOpen={isOpen}
                handleClose={handleClose}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      </>
    );
  }

};

export const useDate = () => {
  const locale = "en";
  const [today, setDate] = React.useState(new Date()); // Save the current date to be able to trigger an update

  React.useEffect(() => {
    const timer = setInterval(() => {
      // Creates an interval which will update the current data every minute
      // This will trigger a rerender every component that uses the useDate hook.
      setDate(new Date());
    }, 60 * 1000);
    return () => {
      clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
    };
  }, []);

  const day = today.toLocaleDateString(locale, { weekday: "long" });
  const date = `${day}, ${today.getDate()} ${today.toLocaleDateString(locale, {
    month: "long",
  })}\n\n`;

  const hour = today.getHours();
  const wish = `Good ${
    (hour < 12 && "Morning") || (hour < 17 && "Afternoon") || "Evening"
  }, `;

  const time = today.toLocaleTimeString(locale, {
    hour: "numeric",
    hour12: true,
    minute: "numeric",
  });

  return {
    date,
    time,
    wish,
  };
};
export default StartKitchenBooking;